import dayjs from 'dayjs';

import { MaintenanceWindow } from 'src/common/maintenance-window';

if (process.env.NODE_ENV !== 'test') {
    if (!import.meta.env['VITE_APP_API_SERVER']) {
        throw new Error('This variable must be set: VITE_APP_API_SERVER');
    }
}

// set the upcoming maintenance window here by reading environment vars
let UPCOMING_MAINTENANCE_WINDOW: MaintenanceWindow | null = null;
if (import.meta.env['VITE_APP_MAINTENANCE_WINDOW_START']) {
    const startTime = import.meta.env['VITE_APP_MAINTENANCE_WINDOW_START'];
    const durationMinutes = import.meta.env['VITE_APP_MAINTENANCE_WINDOW_DURATION_MINUTES'] ? parseInt(import.meta.env['VITE_APP_MAINTENANCE_WINDOW_DURATION_MINUTES']) : undefined;
    UPCOMING_MAINTENANCE_WINDOW = new MaintenanceWindow(
        dayjs(startTime),
        durationMinutes
    );
}

/**
 * Miscellaneous configuration parameters here
 *
 * NOTE: the properties that read `window` are getters on purpose. As plain
 * values they were evaluated when this module was imported, which made a
 * browser environment a requirement for importing anything that reaches
 * `src/config` — and that is most of the api layer, via `src/services/api/url`.
 * Tests of pure functions had to spin up a DOM just to satisfy an import they
 * never used. Keep any future `window` / `document` access lazy for the same
 * reason.
 */
export const Config = {
    get isLocal() {
        return window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
    },

    /**
     * Whether this is the staging deployment (e.g. platform.staging.reffie.me).
     */
    get isStaging() {
        return window.location.hostname.includes('staging');
    },

    /**
     * Split backend and frontend
     */
    useSeparateBackendServer: true,

    /**
     * The backend server to which to submit information
     */
    backendServer: import.meta.env['VITE_APP_API_SERVER'],

    /**
     * The WebSocket server for live updates.
     *
     * Unlike `backendServer` this is NOT required at startup: the `live_updates`
     * feature flag defaults OFF and the var may be absent locally, so a missing
     * value must not throw — it simply means no socket is ever opened.
     */
    wsServer: import.meta.env['VITE_APP_WS_SERVER'],

    /**
     * Maintenance window, which may or may not be in the future
     */
    maintenanceWindow: UPCOMING_MAINTENANCE_WINDOW,
};
